import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as folderActions from 'pages/folders/controllers/actions';
import selectorsGridView from 'common/components/grid-view/controllers/selectors';

import { useGetFolderDetail } from 'common/components/folder/hooks';

const useFolderContentPane = () => {
  const dispatch = useDispatch();

  const visibleContentPane = useSelector(selectorsGridView.makeSelectVisible());

  const selectedItems = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const selectedItem = selectedItems?.[0];

  const currentShortItem = selectedItem;

  const shouldFetchData = visibleContentPane && Boolean(currentShortItem?.id);

  const { data: folderData, isFetching: isLoading } = useGetFolderDetail({
    folderId: currentShortItem?.id,
    isLoadContent: false,
    enabled: shouldFetchData,
    staleTime: 0,
  });

  useEffect(() => {
    if (folderData && shouldFetchData) {
      dispatch(folderActions.updateFolderPrevItemSelected(currentShortItem));
    }
  }, [folderData, shouldFetchData, currentShortItem, dispatch]);

  useEffect(() => {
    if (!visibleContentPane) {
      dispatch(folderActions.updateFolderPrevItemSelected(null));
    }
  }, [dispatch, visibleContentPane]);

  return {
    shortDetail: folderData,
    isLoading,
    contentPaneType: 'folder',
  };
};

export { useFolderContentPane };
